import {
	Box,
	Fieldset,
	PrimaryButton,
	Radio,
	SecondaryButton,
	SmartLink,
	Text,
} from '@stashinvest/ui';
import React, { useState } from 'react';

const LinkPlaidSelection = ({
	accounts,
	linkSelectedAccount,
	setMultipleSelection,
	setAccountName,
	setMaskedNumber,
}) => {
	const [selectedAccountId, setSelectedAccountId] = useState(accounts[0].id);

	return (
		<Box>
			<Fieldset>
				<Text.H3>Choose a checking account to link</Text.H3>
				<Text mb="m">You&apos;ll be able to add cash to invest with this account.</Text>
				{accounts.map((account, key) => {
					return (
						<Radio
							name="accounts"
							key={key}
							checked={account.id == selectedAccountId}
							onChange={() => {
								setAccountName(account.name);
								setMaskedNumber(account.mask);
								setSelectedAccountId(account.id);
							}}
						>
							<Text.H5>
								{account.name} {account.mask}
							</Text.H5>
						</Radio>
					);
				})}
			</Fieldset>
			<Box mt="s24">
				<PrimaryButton
					onClick={() => {
						setMultipleSelection(false);
						linkSelectedAccount(selectedAccountId);
					}}
				>
					Save & Finish
				</PrimaryButton>
				<br />
				<SecondaryButton to="/manage-bank-account" as={SmartLink}>
					Leave without linking
				</SecondaryButton>
			</Box>
		</Box>
	);
};

export default LinkPlaidSelection;
